export default "__VITE_ASSET__845b82f6__"